module.exports = __webpack_public_path__ + "media/images/icons/twotone/dashboard-bbdfce3009dd583e1d9b699048ab7160.svg";